import './index.scss'
import {Header} from "../../components/Header";
import {Content} from "../../components/Content";
import {Footer} from "../../components/Footer";


export function ProductsPage() {
    return (
        <>
            <Header/>
            <Content/>
            <Footer/>
        </>
    )
}
